// AdminLogin.js
import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Snackbar,
  Alert,
  InputAdornment,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import axios from 'axios';
import Navbar from '../Navbar';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [alert, setAlert] = useState({ message: '', severity: '' });
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const auth = params.get('auth');
    if (auth === 'required') {
      setAlert({ message: 'Please login to access the admin panel', severity: 'warning' });
      setOpen(true);
    }
  }, [location.search]);

const handleLogin = async () => {
  try {
    const response = await axios.post('https://reviewhub-lc.onrender.com/api/admin/login', {
      username,
      password,
    });

    const adminData = response.data.admin;
    localStorage.setItem('admin', JSON.stringify(adminData));

    setAlert({ message: response.data.message, severity: 'success' });
    setOpen(true);

    setTimeout(() => {
      navigate('/admin-panel');
    }, 1500);
  } catch (error) {
    const msg = error.response?.data?.message || 'Login failed';
    setAlert({ message: msg, severity: 'error' });
    setOpen(true);
  }
};

return (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(to right, #1e3c72, #2a5298)',
    }}
  >
    <Box
      sx={{
        width: '90%',
        maxWidth: '900px',
        height: '500px',
        display: 'flex',
        boxShadow: 10,
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'white',
      }}
    >
      {/* Left side - Welcome */}
      <Box
        sx={{
          flex: 1,
          background: 'linear-gradient(to right, #1e3c72, #2a5298)',
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 4,
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Welcome
        </Typography>
      <Typography align="center" sx={{ maxWidth: '80%', fontSize: '1.2rem' }}>
  Welcome to the Admin Dashboard! Manage users, resellers, and monitor growth — all in one place. Your tools to power up the platform start here.
</Typography>

      </Box>

      {/* Right side - Login form */}
      <Box
        sx={{
          flex: 1,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: '#f4f4f4',
        }}
      >
        <Typography variant="h5" gutterBottom align="center">
          LOGIN
        </Typography>
        <TextField
          fullWidth
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          onClick={handleLogin}
        >
          Login
        </Button>
      </Box>
    </Box>

    {/* Snackbar alert */}
    <Snackbar open={open} autoHideDuration={3000} onClose={() => setOpen(false)}>
      <Alert onClose={() => setOpen(false)} severity={alert.severity} sx={{ width: '100%' }}>
        {alert.message}
      </Alert>
    </Snackbar>
  </Box>
);

};

export default AdminLogin;
